<template>
  <div>
    <!-- 机构地址弹窗 -->
    <el-dialog
      :visible.sync="dialogCodeVisible"
      top="2%"
      width="65%"
      @open="handleOpen"
    >
      <span slot="title">机构地址</span>
      <!-- 地图容器 -->
      <div class="map-box">
        <div ref="mapRef" style="height: 100%" />
        <!-- 刷新按钮 -->
        <img
          class="refresh-img"
          src="@/assets/location/refresh.png"
          alt=""
          @click="handleRefresh"
        />
      </div>
      <!-- 地址列表表格 -->
      <el-table
        ref="workTableRef"
        :data="list"
        border
        stripe
        :header-cell-style="{ background: '#F0F3F7', color: '#495057' }"
        style="margin-top: 20px"
        max-height="300"
      >
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <img
              style="width: 16px; height: 16px; cursor: pointer"
              src="@/assets/location/address-table.png"
              alt=""
              @click="handleTableCode(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="addressType"
          label="地址类型"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="address"
          label="具体地址"
          :show-overflow-tooltip="true"
        />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: {
    // 地址列表数据
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 弹窗显示状态
      dialogCodeVisible: false,
      // 地图实例
      map: null,
      // 标记点图标实例
      icon: null,
    };
  },
  watch: {
    // 监听地址列表变化，自动添加标记点
    list: {
      handler(newVal) {
        if (this.map && newVal && newVal.length > 0) {
          this.addMarkers();
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    // 组件销毁前销毁地图实例
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    // 初始化图标实例（单例模式，避免重复创建）
    initIcon() {
      if (!this.icon) {
        this.icon = new AMap.Icon({
          size: new AMap.Size(12, 15),
          image: require("@/assets/location/address.png"),
          imageSize: new AMap.Size(12, 15),
        });
      }
      return this.icon;
    },
    // 创建标记点
    createMarker(item) {
      // 解析经纬度
      const lng = parseFloat(item.lng);
      const lat = parseFloat(item.lat);
      // 验证坐标有效性
      if (isNaN(lng) || isNaN(lat) || lng <= 0 || lat <= 0) return null;

      // 创建标记点
      const marker = new AMap.Marker({
        position: [lng, lat],
        icon: this.initIcon(),
        title: item.address || "",
        offset: new AMap.Pixel(-20, -50),
      });

      // 绑定点击事件
      marker.on("click", () => {
        this.focusMarker(marker, item.address);
      });

      return marker;
    },
    // 聚焦到指定标记点
    focusMarker(marker, address) {
      // 清除其他标记点，只保留当前点击的
      this.map.clearMap();
      this.map.add(marker);

      // 获取标记点位置并移动地图
      const position = marker.getPosition();
      setTimeout(() => {
        this.map && this.map.setZoomAndCenter(20, position);
      }, 50);

      // 显示信息窗体
      this.showInfoWindow(position, address);
    },
    // 显示信息窗体
    showInfoWindow(position, address) {
      const infoWindow = new AMap.InfoWindow({
        isCustom: false,
        content: `<div style="padding: 10px; font-size: 14px;">${
          address || ""
        }</div>`,
        offset: new AMap.Pixel(-15, -55),
      });
      infoWindow.open(this.map, position);
    },
    // 弹窗打开时的处理
    handleOpen() {
      if (!this.map) {
        this.initMap();
      } else {
        this.addMarkers();
      }
    },
    // 初始化地图
    initMap() {
      this.$nextTick(() => {
        // 确保DOM元素存在
        if (!this.$refs.mapRef) {
          setTimeout(() => this.initMap(), 100);
          return;
        }

        // 创建地图实例
        this.map = new AMap.Map(this.$refs.mapRef, {
          zoom: 12,
          resizeEnable: true,
          mapStyle: "amap://styles/70f782dd9696b05f4063dfcf88a342b2",
          center: [116.397428, 39.90923],
        });

        // 添加标记点
        this.addMarkers();
      });
    },
    // 添加标记点
    addMarkers() {
      if (!this.map) return;

      // 清除现有标记点
      this.map.clearMap();

      const data = this.list || [];
      const markers = [];

      // 遍历数据创建标记点
      data.forEach((item) => {
        const marker = this.createMarker(item);
        if (marker) {
          markers.push(marker);
          this.map.add(marker);
        }
      });

      // 自动调整视野显示所有标记点
      if (markers.length > 0) {
        this.map.setFitView(markers);
      }
    },
    // 显示弹窗
    show() {
      this.dialogCodeVisible = true;
    },
    // 刷新地图
    handleRefresh() {
      this.initMap();
    },
    // 表格操作列点击事件
    handleTableCode(row) {
      const lng = parseFloat(row.lng);
      const lat = parseFloat(row.lat);

      // 验证地图和坐标有效性
      if (!this.map || isNaN(lng) || isNaN(lat)) return;

      // 创建标记点
      const marker = new AMap.Marker({
        position: [lng, lat],
        icon: this.initIcon(),
        title: row.address || "",
        offset: new AMap.Pixel(-20, -50),
      });

      const position = new AMap.LngLat(lng, lat);

      // 清除其他标记点，添加当前标记点
      this.map.clearMap();
      this.map.add(marker);

      // 移动地图到指定位置
      setTimeout(() => {
        this.map && this.map.setZoomAndCenter(20, position);
      }, 50);

      // 显示信息窗体
      this.showInfoWindow(position, row.address);
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
</style>
<style lang="scss" scoped>
@import "./address.scss";
</style>
